import { render, staticRenderFns } from "./WidddiFlux.vue?vue&type=template&id=5d2c6806"
import script from "./WidddiFlux.vue?vue&type=script&lang=js"
export * from "./WidddiFlux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports